import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';

import Pagination from '../Pagination';
import ReportDetailsTableHeader from '../ReportDetailsTableHeader';
import ReportDetailsTableColumn from '../ReportDetailsTableColumn';
import noop from '../../utils/noop';

import { filterRecordsByPage, filterByFiltering } from '../../selectors/selectors';

import './styles.css';

const ReportsDetailsTable = ({
  headers,
  columns,
  records,
  activePage,
  paginate,
  filtering,
  filter,
  noRecordsMessage
}) => {
  const filterRecords = filterByFiltering(records, filtering);
  const paginated = filterRecordsByPage(filterRecords, activePage);

  return (
    <div>
      {records && records.length > 0
        ? <Pagination
            activePage={activePage}
            pageCount={paginated.pageCount}
            pageSelect={paginate}
          >
            <table className="table table-fixed">
              <thead>
                <tr>
                  {headers.map(header =>
                    <ReportDetailsTableHeader
                      key={header.title}
                      keyName={header.title}
                      records={records}
                      filter={filter}
                      filtering={filtering}
                      {...header}
                    />
                  )}
                </tr>
              </thead>
              <tbody>
                {paginated.recordsByPage.map((record, i) =>
                  <tr key={i}>
                    {columns.map(column =>
                      <ReportDetailsTableColumn
                        key={column.keyName}
                        keyName={column.keyName}
                        record={record}
                        {...column}
                      />
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          </Pagination>
        : <div className="empty-records">
            <p>{noRecordsMessage}</p>
          </div>}
    </div>
  );
};

ReportsDetailsTable.propTypes = {
  paginate: PropTypes.func.isRequired,
  activePage: PropTypes.number.isRequired,
  filtering: PropTypes.object.isRequired,
  filter: PropTypes.func.isRequired,
  headers: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  records: PropTypes.array,
  noRecordsMessage: PropTypes.string
};

ReportsDetailsTable.defaultProps = {
  paginate: noop,
  activePage: 1,
  filtering: {},
  filter: noop,
  headers: [],
  columns: [],
  noRecordsMessage: 'There are no records at this time.'
};

export default ReportsDetailsTable;
